export default __webpack_public_path__ + "static/media/scissor.8ed1196a.png";